var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuobiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 50,
    viewBox: "0 0 145 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7925_89813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0178 17.6499C19.4932 23.5917 13.5741 28.9677 11.5732 32.3631C9.65442 35.6189 8.98605 38.6962 10.3896 44.6398C10.4641 44.9553 10.1491 45.2311 9.85526 45.0959C7.34773 43.9418 0.966068 40.4802 0.966064 32.2277C0.966061 20.5871 13.8085 20.1713 13.2049 4.4164C13.1928 4.0997 13.5383 3.88446 13.7968 4.06691C17.9982 7.03285 20.5178 11.9864 20.0178 17.6499Z",
    fill: "#0CA28B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6409 45.5666C11.4903 45.5204 11.3852 45.3827 11.3792 45.2249C11.2331 41.3633 13.3053 38.8398 15.6288 36.9676C20.7862 32.8118 23.9662 27.1997 22.7076 20.7061C22.6325 20.3188 23.0853 20.0631 23.3382 20.3654C24.5514 21.8156 25.7872 23.7809 26.4712 25.2135C29.7699 32.3188 28.0095 40.4615 20.1158 44.5704C17.6445 45.8006 14.71 46.5067 11.6409 45.5666Z",
    fill: "#3BBEAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7712 14.5615V26.8307H42.0241V16.1401C42.0241 15.2681 41.3382 14.5615 40.4918 14.5615H36.527V43.7997C36.527 44.6713 37.2133 45.3784 38.0593 45.3784H42.0241V31.7796H53.7712V43.7997C53.7712 44.6713 54.457 45.3784 55.3035 45.3784H59.2683V16.1401C59.2683 15.2681 58.582 14.5615 57.7355 14.5615H53.7712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2996 21.8169V36.4368C77.2996 37.7653 76.6289 39.0246 75.4915 39.6889C72.315 41.544 69.0287 39.227 69.0287 36.1715V23.3969C69.0287 22.5238 68.3288 21.8164 67.4651 21.8164H63.4033H63.4028V36.6931C63.4028 41.4794 67.2776 45.3954 72.0126 45.3954H74.315C79.0504 45.3954 82.9247 41.4794 82.9247 36.6928V23.3969C82.9247 22.5238 82.2248 21.8164 81.3616 21.8164H77.2996V21.8169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.712 45.3776H143.688V24.6425C143.688 23.7681 142.999 23.0596 142.151 23.0596H138.175V43.7943C138.175 44.6687 138.863 45.3776 139.712 45.3776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.965 20.711C142.658 20.711 144.031 19.3345 144.031 17.6363C144.031 15.938 142.658 14.5615 140.965 14.5615C139.271 14.5615 137.898 15.938 137.898 17.6363C137.898 19.3345 139.271 20.711 140.965 20.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.673 35.6016C102.673 38.4106 100.414 40.2806 97.6538 40.2806C94.893 40.2806 92.6344 38.4106 92.6344 35.6016V31.593C92.6344 28.784 94.893 26.9139 97.6538 26.9139C100.414 26.9139 102.673 28.784 102.673 31.593V35.6016ZM97.6538 21.8164C91.817 21.8164 87.0409 26.0649 87.0409 32.0037V35.2159C87.0409 41.155 91.817 45.3781 97.6538 45.3781C103.491 45.3781 108.266 41.155 108.266 35.2159V32.0037C108.266 26.0649 103.491 21.8164 97.6538 21.8164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.131 35.6084C128.131 38.4154 125.857 40.2843 123.079 40.2843C120.3 40.2843 118.027 38.4154 118.027 35.6084V31.6024C118.027 28.7953 120.3 26.9267 123.079 26.9267C125.857 26.9267 128.131 28.7953 128.131 31.6024V35.6084ZM123.079 21.8325C121.243 21.8325 119.511 22.2471 117.998 22.9985V16.1384C117.998 15.2675 117.299 14.5615 116.436 14.5615H112.397V35.2228C112.397 41.158 117.204 45.3784 123.079 45.3784C128.953 45.3784 133.76 41.158 133.76 35.2228V32.0129C133.76 26.0781 128.953 21.8325 123.079 21.8325Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7925_89813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 42,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobiIcon);
export default __webpack_public_path__ + "static/media/huobiIcon.6bb6399eda053fbf62b49c7c183380cf.svg";
export { ForwardRef as ReactComponent };